
import { useSlots } from 'vue'

export const useSlot = () => {
  const slots = useSlots()

  const hasSlot = (name: string) => {
    if (slots[name]) return slots[name]!()?.length
    return false
  }

  return {
    hasSlot,
  }
}
